import { createRoot } from "react-dom/client";
import DownloadScreen from "./downloadPage";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<DownloadScreen tab="home" />);
